import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { delay, filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SearchUiStateService {
  private _closeAutocomplete = new BehaviorSubject<boolean>(false);
  private _closeSearch = new BehaviorSubject<boolean>(false);
  private _openSearch = new BehaviorSubject<boolean>(false);

  get autocompleteClosed() {
    return this._closeAutocomplete.asObservable().pipe(filter(Boolean), delay(400));
  }

  get searchClosed() {
    return this._closeSearch.asObservable().pipe(filter(Boolean));
  }

  get searchOpened() {
    return this._openSearch.asObservable().pipe(filter(Boolean));
  }

  closeAutoComplete() {
    this._closeAutocomplete.next(true);
  }

  closeSearch() {
    this._closeSearch.next(true);
    this._openSearch.next(false);
  }

  openSearch() {
    this._openSearch.next(true);
    this._closeSearch.next(false);
  }
}
